module.exports = __webpack_public_path__ + "img/registered.6e14804c.png";